<template>	
	<div class="row">
		<div class="col-8" style="margin: auto;">
		<div style="margin-top:100px;">
			<h3 style="color:#000">订单：“{{orderId}}” 进度</h3>
		</div>
		
		<div v-show="wait"><img src="./../assets/img/loading.gif" style="margin: auto;width:150px;"/></div>
		
		<div style="margin-top:20px;">
			<el-steps :active="finishStep" align-center>
			  <el-step title="创建订单" description="业务创建订单">{{proOrder.cretime}}</el-step>
			  <el-step title="设计绘图" description="工程设计绘图"></el-step>
			  <el-step title="物料准备" description="生产或采购物料"></el-step>
			  <el-step title="装备" description="安装调试"></el-step>
			</el-steps>
		</div>
		
		<div v-show="lc" style="margin-top:20px;">
			<el-collapse accordion>
			  <el-collapse-item>
			    <template slot="title">
			      1、设计绘图 
				  <span v-if="proOrder.designerId!=null"><i class="bi-check-circle" v-if="" style="color:green;"></i></span>
				  <span v-if="proOrder.designerId==null>0"><i class="bi-doing" v-if="" style="color:green;"></i></span>
			    </template>
				<div>
				  <span v-if="proOrder.designerId!=null">已完成设计绘图</span>
				  <span v-if="proOrder.designerId==null>0">工程是正在努力中</span>
				</div>
			  </el-collapse-item>
			  <el-collapse-item>
				  <template slot="title">
				    2、物料准备 
				    <span v-if="pl"><i class="bi-check-circle" v-if="" style="color:green;"></i></span>
				    <span v-if="!pl"><i class="bi-doing" v-if="" style="color:green;"></i></span>
				  </template>
               <div v-if="proName.length>0">
					<table class="table-hover table table-striped" style="width:100%;">
						<thead>					
						<tr>
							<th>序号</th><th>零件名称</th><th>生产</th><th>配料</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="(item,index) in proName" :key="index">
							<td>{{index+1}}</td>
							<td>{{item.componentName}}</td>
							<td>
							<span v-for="(item2,index) in item.produce" :key="index">
								<i class="bi-check-circle" v-if="item2.state=='W'" style="color: green;"></i>{{item2.currGx}}<br/>
							</span>
							</td>
							<td><i class="bi-check-circle" v-if="item.status==true" style="color:green;"></i></td>
						</tr>
						</tbody>				
					</table>
			   </div>
			  </el-collapse-item>
			  <el-collapse-item>
				  <template slot="title">
				    3、装配
				    <span v-if="orderState==='装配完成'"><i class="bi-check-circle" style="color:green;"></i></span>
				    <span v-if="orderState==='装配中'"><i class="bi-doing" style="color:green;"></i></span>
				  </template>
			  </el-collapse-item>
			</el-collapse>
		</div>
		</div>
	</div>		
	

</template>

<script>
	import Cookies from "js-cookie";
	import { Message,MessageBox} from "element-ui";
	export default {
	  data() {
	    return {
		  orders:[],
		  proOrder:{},
		  orderState:"",
		  proName:[],
		  orderId:"",
		  lc:false,
		  wait:false,
		  finishStep:1,
		  pl:true,//配料情况
	    };
	  },
	  created() {
		  this.status();
	  },
	  methods: {
	  status(){
	  	this.proName=[];
	  	this.orderId=this.$route.query.id;
	  	let obj={
	  		orderNo:this.orderId
	  	}
	  	this.$axios.post(this.$serverUrl+"/toYdn/getOrderStatusByOrderNo",obj).then(response => {			
	  		  if(response.data.state==200){
	  			this.wait=false;
	  			let proOrderDetail=response.data.data.proOrderDetail;
	  			let proTaskVo=response.data.data.proTaskVo;
	  			let order=response.data.data.proOrder;
	  			if(order.length>0){
	  				this.proOrder=order[0];
					if(order[0].designerId!=null){
						this.finishStep=this.finishStep+1;
					}
	  			}				
	  			if(proOrderDetail.length>0){
	  				if(proOrderDetail[0].state=="ZPZ"){
	  				this.orderState="装配中";
	  				}
	  				if(proOrderDetail[0].state=="CMP"){
					this.finishStep=this.finishStep+1;
	  				this.orderState="装配完成";
	  				}
	  				if(proOrderDetail[0].state=="ZPS"){
	  				this.orderState="装配暂停";
	  				}
	  			}

	  			for(let i=0;i<proOrderDetail.length;i++){
	  				let pro={};
	  				pro.componentName=proOrderDetail[i].componentName.trim();
	  				//物料准备
	  				pro.produce=[];
	  				if(proOrderDetail[i].type==0){
	  					for(let j=0;j<proTaskVo.length;j++){					
	  					if(proTaskVo[j].name==pro.componentName){
	  					pro.produce.push(proTaskVo[j])
	  					}
	  					}					
	  				}else{
	  					pro.produce.push({currGx:"现货/采购"})
	  				}
	  				//配料情况
	  				if(proOrderDetail[i].checkerId!=null){
	  					if(proOrderDetail[i].matchQuantity!=null){
	  					pro.status=true;
	  					}else{
	  					pro.status=false;
						this.pl=false;
	  					}
	  				}else{
						this.pl=false;
	  					pro.status=false
	  				}
	  				this.proName.push(pro);
	  				//if(!this.proName.includes(res.data.data[i].componentName)){this.proName.push(res.data.data[i].componentName)}
	  				}
	  			this.lc=true;
				if(this.pl){
					this.finishStep=3;
				}
				if(this.orderState=="装配完成"){
					this.finishStep=4;
				}
				//console.log(this.orderState);
	  		  }
	      });
		}
	},
	}
</script>

<style>
</style>